export interface NavigationItem {
  id: string;
  title: string;
  type: 'item' | 'collapse' | 'group';
  translate?: string;
  icon?: string;
  hidden?: boolean;
  fontIcon?: boolean;
  url?: string;
  classes?: string;
  groupClasses?: string;
  exactMatch?: boolean;
  external?: boolean;
  target?: boolean;
  breadcrumbs?: boolean;
  children?: NavigationItem[];
  link?: string;
  description?: string;
  path?: string;
}

export const NavigationItems: NavigationItem[] = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'group',
    icon: 'icon-navigation',
    children: [
      {
        id: 'default',
        title: 'Default',
        type: 'item',
        classes: 'nav-item',
        url: '/dashboard',
        icon: 'solar:home-bold',
        breadcrumbs: false
      },
      {
        id: 'default',
        title: 'Attendance',
        type: 'item',
        classes: 'nav-item',
        url: '/attendance',
        icon: 'solar:user-bold',
        breadcrumbs: false
      }
    ]
  },
  {
    id: 'authentication',
    title: 'Authentication',
    type: 'group',
    icon: 'icon-navigation',
    children: [
      {
        id: 'login',
        title: 'Login',
        type: 'item',
        classes: 'nav-item',
        url: '/login',
        icon: 'solar:login-3-bold',
        target: true,
        breadcrumbs: false
      },
      {
        id: 'facebook-login',
        title: 'Facebook-login',
        type: 'item',
        classes: 'nav-item',
        url: '/facebook-login',
        icon: 'solar:alarm-remove-line-duotone',
        breadcrumbs: false
      },
      {
        id: 'auth-callback',
        title: 'auth-callback',
        type: 'item',
        classes: 'nav-item',
        url: '/auth-callback',
        icon: 'solar:add-folder-outline',
        breadcrumbs: false
      },
      {
        id: 'forget',
        title: 'Forget Password',
        type: 'item',
        classes: 'nav-item',
        url: '/forget',
        icon: 'solar:key-outline',
        target: true,
        breadcrumbs: false
      }
    ]
  },
  {
    id: 'utilities',
    title: 'Components',
    type: 'group',
    icon: 'icon-navigation',
    children: [
      {
        id: 'qr-generator',
        title: 'QR Generator',
        type: 'item',
        classes: 'nav-item',
        url: '/qr-generator',
        icon: 'fa-solid fa-square-plus',
        fontIcon: true
      },
      {
        id: 'qr-scanner',
        title: 'QR Scanner',
        type: 'item',
        classes: 'nav-item',
        url: '/qr-scanner',
        icon: 'fa-solid fa-qrcode',
        fontIcon: true
      },
      {
        id: 'custom-date-picker',
        title: 'Custom Date Picker',
        type: 'item',
        classes: 'nav-item',
        url: '/formio-custom',
        icon: 'fa-solid fa-qrcode',
        fontIcon: true
      },
      {
        id: 'formio-builder',
        title: 'Form Builder',
        type: 'item',
        classes: 'nav-item',
        url: '/formio-builder',
        icon: 'fa-solid fa-table-list',
        fontIcon: true
      },
      {
        id: 'forms-list',
        title: 'Forms List',
        type: 'item',
        classes: 'nav-item',
        url: '/forms-list',
        icon: 'fa-solid fa-list-check',
        fontIcon: true
      },
      {
        id: 'formio-data',
        title: 'Form Data',
        type: 'item',
        classes: 'nav-item',
        url: '/formio-data',
        icon: 'fa-solid fa-table-list',
        fontIcon: true
      },
      {
        id: 'case-management',
        title: 'Case Management',
        type: 'item',
        classes: 'nav-item',
        url: '/case-management',
        icon: 'fa-solid fa-briefcase',
        fontIcon: true
      },
      {
        id: 'group-app',
        title: 'Group App & Lending',
        type: 'item',
        classes: 'nav-item',
        url: '/group-app',
        icon: 'fa-solid fa-users',
        fontIcon: true
      },
      {
        id: 'app-form',
        title: 'App Form',
        type: 'item',
        classes: 'nav-item',
        url: '/app-form',
        icon: 'fa-solid fa-mobile-alt',
        fontIcon: true
      },
      {
        id: 'page-master',
        title: 'Page Master Form',
        type: 'item',
        classes: 'nav-item',
        url: '/page-master',
        icon: 'fa-solid fa-file-alt',
        fontIcon: true
      },
      {
        id: 'encrypted-form',
        title: 'Encrypted Form',
        type: 'item',
        classes: 'nav-item',
        url: '/encrypted-form',
        icon: 'fa-solid fa-lock',
        fontIcon: true
      }
    ]
  }
];
